/* eslint-disable jsx-a11y/label-has-associated-control */
import { Form } from 'semantic-ui-react';
import { useState } from '@wordpress/element';
import BarChart from './BarChart';
import data from '../data.json';

const FairTreatment = () => {
    const [workplace, setWorkplace] = useState(
        'Blacks in the U.S. are treated less fairly than whites',
    );
    const [police, setPolice] = useState(
        'Blacks in the U.S. are treated less fairly than whites',
    );
    const [elections, setElections] = useState(
        'Blacks in the U.S. are treated less fairly than whites',
    );

    return (
        <>
            <div className="content-box">
                <h3 id="treated-fairly">Are blacks treated fairly?</h3>
                <section id="in-workplace">
                    <p>
                        Blacks are nearly three times as likely as whites to say
                        black people in our country are treated less fairly than
                        whites in the workplace. Among whites, two-thirds say
                        both groups are treated about equally. Very small shares
                        of blacks or whites say that whites are treated less
                        fairly than blacks in this or any of the other areas
                        tested in the survey. The survey also asked respondents
                        about the treatment of blacks in their community and
                        found that people tend to view their own communities as
                        more fair than the country as a whole across each of the
                        items tested.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            How blacks are treated in the workplace
                        </h4>
                        <div className="radio-container">
                            <Form.Radio
                                label="Blacks in the U.S. are treated less fairly than whites"
                                checked={
                                    'Blacks in the U.S. are treated less fairly than whites' ===
                                    workplace
                                }
                                value="Blacks in the U.S. are treated less fairly than whites"
                                onClick={() =>
                                    setWorkplace(
                                        'Blacks in the U.S. are treated less fairly than whites',
                                    )
                                }
                            />
                            <Form.Radio
                                label="Blacks and whites are treated about equally"
                                checked={
                                    'Blacks and whites are treated about equally' ===
                                    workplace
                                }
                                value="Blacks and whites are treated about equally"
                                onClick={() =>
                                    setWorkplace(
                                        'Blacks and whites are treated about equally',
                                    )
                                }
                            />
                        </div>
                        {'Blacks in the U.S. are treated less fairly than whites' ===
                            workplace && (
                            <BarChart data={data.unfairWorkplace} />
                        )}
                        {'Blacks and whites are treated about equally' ===
                            workplace && <BarChart data={data.fairWorkplace} />}
                    </div>
                </section>
                <section id="treated-fairly">
                    <p>
                        Blacks are far more likely than whites to say black
                        people in the U.S. are treated less fairly than whites
                        by the police. While the vast majority of blacks say
                        this is the case, half of whites do. White Democrats are
                        considerably more likely than white Republicans and
                        white independents to say that black people are treated
                        less fairly by the police. Even so, white Democrats are
                        less likely than black Democrats to say this is the
                        case.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            How blacks are treated in dealing with the police
                        </h4>
                        <div className="radio-container">
                            <Form.Group inline>
                                <Form.Radio
                                    label="Blacks in the U.S. are treated less fairly than whites"
                                    checked={
                                        'Blacks in the U.S. are treated less fairly than whites' ===
                                        police
                                    }
                                    value="Blacks in the U.S. are treated less fairly than whites"
                                    onClick={() =>
                                        setPolice(
                                            'Blacks in the U.S. are treated less fairly than whites',
                                        )
                                    }
                                />
                                <Form.Radio
                                    label="Blacks and whites are treated about equally"
                                    checked={
                                        'Blacks and whites are treated about equally' ===
                                        police
                                    }
                                    value="Blacks and whites are treated about equally"
                                    onClick={() =>
                                        setPolice(
                                            'Blacks and whites are treated about equally',
                                        )
                                    }
                                />
                            </Form.Group>
                        </div>
                        {'Blacks in the U.S. are treated less fairly than whites' ===
                            police && <BarChart data={data.unfairPolice} />}
                        {'Blacks and whites are treated about equally' ===
                            police && <BarChart data={data.fairPolice} />}
                    </div>
                </section>
                <section id="family-instability">
                    <p>
                        Blacks are about twice as likely as whites to say black
                        people in the U.S. are treated less fairly when voting
                        in elections. About four-in-ten of both white and black
                        Democrats say blacks in the U.S. are treated less fairly
                        when voting in elections. Just 5% of white Republicans
                        agree. The survey also found large racial gaps when it
                        comes to blacks in the U.S. being treated less fairly in
                        the courts, when applying for a loan or mortgage and in
                        stores and restaurants.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            How blacks are treated when voting in elections
                        </h4>
                        <div className="radio-container">
                            <Form.Radio
                                label="Blacks in the U.S. are treated less fairly than whites"
                                checked={
                                    'Blacks in the U.S. are treated less fairly than whites' ===
                                    elections
                                }
                                value="Blacks in the U.S. are treated less fairly than whites"
                                onClick={() =>
                                    setElections(
                                        'Blacks in the U.S. are treated less fairly than whites',
                                    )
                                }
                            />
                            <Form.Radio
                                label="Blacks and whites are treated about equally"
                                checked={
                                    'Blacks and whites are treated about equally' ===
                                    elections
                                }
                                value="Blacks and whites are treated about equally"
                                onClick={() =>
                                    setElections(
                                        'Blacks and whites are treated about equally',
                                    )
                                }
                            />
                        </div>
                        {'Blacks in the U.S. are treated less fairly than whites' ===
                            elections && <BarChart data={data.unfairVoting} />}
                        {'Blacks and whites are treated about equally' ===
                            elections && <BarChart data={data.fairVoting} />}
                    </div>
                </section>
            </div>
        </>
    );
};

export default FairTreatment;
